import React, { useEffect, useRef } from 'react';
import Partners from '../../Components/Homepage/Partners';
import Footer from '../../Components/Layout/Footer';
import Homepage from '../../Components/Homepage/Homepage';
import { useLocation } from 'react-router-dom';

const LandingPage = (() => {
  const targetDivRef = useRef<HTMLDivElement>(null);
  const location = useLocation();
  useEffect(() => {
    if (location.state?.scrollTo && location.state.scrollTo === 'targetDiv' && targetDivRef.current) {
      targetDivRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location]);
  return (
    <div>
      <Homepage />
      <Partners />
      <Footer />
    </div>
  );
});
export default LandingPage;
